import BaseComponent from './BaseComponent';
import SearchAutocomplete from './SearchAutocomplete';
import Datepicker from './Datepicker';
import $ from 'jquery';

class ArticleSelector extends BaseComponent {

    loadOnConstructor(){
		this.close = this.close.bind(this);
		this.assignCallback = this.assignCallback.bind(this);
		this.renderButtons = this.renderButtons.bind(this);
    	this.renderArticlesFilter = this.renderArticlesFilter.bind(this);
    	this.changeArticlesHandler = this.changeArticlesHandler.bind(this);
    	this.getArticlesCallback = this.getArticlesCallback.bind(this);
    	this.articleSelected = this.articleSelected.bind(this);
    	this.setCurrentSelection = this.setCurrentSelection.bind(this);
		this.changeDateRangeHandler = this.changeDateRangeHandler.bind(this);
		this.callGetArticles = this.callGetArticles.bind(this);
		this.filterArticles = this.filterArticles.bind(this);
		this.handleStatusChange = this.handleStatusChange.bind(this);
		this.validateFields = this.validateFields.bind(this);
		this.setSelectedBooking = this.setSelectedBooking.bind(this);
		this.adjustDateToTimezone = this.adjustDateToTimezone.bind(this);
		this.checkBookingDates = this.checkBookingDates.bind(this);

		const now = new Date()
		const end_date = new Date(now)
		end_date.setMonth(now.getMonth()+1)
		end_date.setDate(0)
		end_date.setHours(23)
		end_date.setMinutes(59)
		end_date.setSeconds(59)

		const booking = this.props.loadedBooking
		this.state = {
			articlesFromApi: [],
			start_date: booking && booking.start_date?booking.start_date:now,
			end_date: booking && booking.end_date?booking.end_date:end_date,
			currentSelection: booking && booking.currentSelection?booking.currentSelection:0
		};

		this.getCommonInterface(this.getCommonInterfaceCallback);
		this.callGetArticles();
    }

	adjustDateToTimezone(dateObject, fromServer, toISOString){
		let modifiedDateObject = new Date(typeof dateObject === 'object'?dateObject.getTime():dateObject);
		let hoursFromTimezoneOffset = (modifiedDateObject.getTimezoneOffset()*-1) / 60;

		hoursFromTimezoneOffset = fromServer?hoursFromTimezoneOffset*-1:hoursFromTimezoneOffset


		const numberOfMlSeconds = dateObject.getTime();
    	const addMlSeconds = (hoursFromTimezoneOffset * 60) * 60000;
		
    	const newDateObj = new Date(numberOfMlSeconds - addMlSeconds);


		//modifiedDateObject.setHours(modifiedDateObject.getHours()+hoursFromTimezoneOffset);

		return toISOString?newDateObj.toISOString():newDateObj;
	}

	setSelectedBooking(selectedBooking){
		let articles = []
		if(selectedBooking.article !== undefined){
			articles = this.state.articlesFromApi.filter(art => String(selectedBooking.article) === String(art._id))
		}

		const articleExists = this.state.articlesFromApi.filter(art => art._id === selectedBooking.article)
		let newArticlesFromApi = JSON.parse(JSON.stringify(this.state.articlesFromApi))
		if(articleExists.length === 0){
			newArticlesFromApi = articleExists.join(newArticlesFromApi)
		}

		const article = articles.length>0?articles[0]:undefined
		if(article){
			const index = selectedBooking.billCode?selectedBooking.billCode: 0
			let booking = article?article.bookings.find(bk => bk.bill_code === index):undefined

			if(!booking) booking = selectedBooking.bookings[0]??undefined
			const startDate = selectedBooking.showAllArticles? undefined: 
					booking?this.adjustDateToTimezone(new Date(booking.start_date)):undefined

			const endDate = selectedBooking.showAllArticles? undefined: 
					booking?this.adjustDateToTimezone(new Date(booking.end_date)):undefined
			this.setState(prevState => {
				return {
					...prevState,
					showAllArticles: selectedBooking.showAllArticles,
					selectedArticles: article,
					article,
					billCode: selectedBooking.billCode,
					status: booking?booking.booking_status+'':undefined,
					articlesFromApi: newArticlesFromApi,
					start_date: startDate,
					end_date: endDate,
					currentSelection: {completeName: article.name, _id: article._id}
				}
			},this.callGetArticles)
		}else{

			const now = new Date()
			const end_date = new Date(now)
			end_date.setMonth(now.getMonth()+1)
			end_date.setDate(0)
			end_date.setHours(23)
			end_date.setMinutes(59)
			end_date.setSeconds(59)

			this.setState(prevState => {
				return {
					...prevState,
					article: undefined,
					status: 0+'',
					start_date: now,
					end_date: end_date,
					currentSelection: 0,
					selectedArticles: undefined
				}
			},this.callGetArticles)
		}
	}

	callGetArticles(){
		let params = []
		if(!this.state.showAllArticles && this.state.start_date && this.state.end_date){
			const startDate = this.dateToString(this.state.start_date)
			const endDate = this.dateToString(this.state.end_date)
			params = [
				{name: 'start_date', value: startDate},
				{name: 'end_date', value: endDate},
			]
		}
		let api = this.getApi();
		api.getArticles(params,this.getArticlesCallback);
	}

	dateToString(dateObject){
		const hoursFromTimezoneOffset = (dateObject.getTimezoneOffset() * -1) / 60;
        let dateToString = new Date(dateObject.getTime());
        dateToString.setHours(dateObject.getHours() + hoursFromTimezoneOffset);

		return dateToString.toISOString()
	}

    getArticlesCallback(response){
		if(response.status === 'OK'){
			this.filterArticles(response.articles)
		}
    }

	filterArticles(articles){
		const startDateStr = this.state.start_date ? this.dateToString(this.state.start_date) : null
		const endDateStr = this.state.end_date ? this.dateToString(this.state.end_date) : null

		const arts = articles.filter(art => {
			if(!art.bookings || art.bookings.length === 0) return true

			const hasConflict = art.bookings.some(booking => {
				// Artículo vendido: nunca disponible independientemente de fechas
				if(parseFloat(booking.booking_status) === 5) return true

				// Si no hay rango seleccionado no filtramos por fechas
				if(!startDateStr || !endDateStr) return false

				// Algoritmo estándar de solapamiento:
				// dos rangos se solapan si uno empieza antes de que el otro termine
				return booking.start_date < endDateStr && booking.end_date > startDateStr
			})

			return !hasConflict
		})
		.map(art => {
			art.completeName = art.name+' ('+art.code+')';
			return art;
		});

		const allArticles = JSON.parse(JSON.stringify(articles)).map(art => {
			art.completeName = art.name+' ('+art.code+')';
			return art
		})

		this.setState(prevState => {
			return {
				...prevState,
					articlesFromApi: this.state.showAllArticles?allArticles:arts
			}
		}, this.getAllArticles);
	}

    close(){
		$("#article-selector-component").modal('toggle');
    }

    assignCallback(button){
		if(button.close && button.close) this.close();
		if(button.callback){ 
			if(this.validateFields()){
				button.callback();this.close();
			}
		}
    }

	validateFields(){
		if(this.state.status === undefined || parseFloat(this.state.status) === 0){
			alert("Debe seleccionar un estado")
			return false
		}

		let bookingsReturn = true

		const completeArticle = this.state.allArticles?.find(art => String(art._id) === String(this.state.article?._id))

		if(completeArticle && completeArticle.bookings){

			const params = this.getUrlParams()
			const booking = {
				end_date: this.state.end_date, 
				start_date: this.state.start_date, 
				status: this.state.status, 
				article: this.state.article,
				checkBill: params.bill_id?false:true
			}

			bookingsReturn = this.checkBookingDates(completeArticle.bookings, booking)
			if(!bookingsReturn){
				alert("Por favor, compruebe las fechas de la reserva. Hay solapamiento con otra reserva")
			}
		
		}
		return bookingsReturn
	}

	checkBookingDates(bookings, booking){
		let returnedValue = true
		bookings.forEach(bk => {
			// Al editar una factura existente, ignoramos la reserva de esa misma factura
			// para evitar que el artículo se bloquee contra sí mismo
			if(!booking.checkBill && String(this.state.billCode) === String(bk.bill_code)){
				return
			}

			const newStart = this.dateObjectToStringCompare(booking.start_date)
			const newEnd   = this.dateObjectToStringCompare(booking.end_date)

			if(newStart < bk.end_date && newEnd > bk.start_date){
				returnedValue = false
			}
		})

		return returnedValue
	}

	dateObjectToStringCompare(d){
		const date = new Date(d)
		const offset = (date.getTimezoneOffset()*-1) / 60;
		date.setHours(date.getUTCHours() + offset,date.getUTCMinutes(),date.getUTCMinutes())

		return `${date.getFullYear()}-${("0" + (date.getMonth()+1)).slice(-2)}-${("0" + (date.getDate())).slice(-2)}T`+
			`${("0" + date.getHours()).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}:${("0" + date.getSeconds()).slice(-2)}:${("0" + date.getMilliseconds()).slice(-3)}Z`
	}

    render() {
    	return (
		<div className="modal fade" id="article-selector-component" tabIndex="-1" role="dialog" 
			aria-labelledby="ModalTitleLabel" aria-hidden="true">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="ModalTitleLabel">
							{this.getTrad("selectArticle")}
						</h5>
						<button type="button" className="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
						<>
    							{this.renderArticlesFilter()}
						</>
					</div>
					<div className="modal-footer">
						{this.renderButtons()}
					</div>
				</div>
			</div>
		</div>
        )
    }

    renderArticlesFilter(){

		return this.state.articlesFromApi?
			<>
			<div className="row">
				<div className='col-3'>
					Fecha inicio
				</div>
				<div className='col-9'>
				<Datepicker selected={this.state.start_date} dateFormat="dd/MM/Y HH:mm" showTimeSelect={true} 
					name="start_date" className='form-control' onChange={this.changeDateRangeHandler}  />
				</div>
			</div>
			<div className="row mt-2">
				<div className='col-3'>
					Fecha fin
				</div>
				<div className='col-9'>
					<Datepicker selected={this.state.end_date} dateFormat="dd/MM/Y HH:mm" showTimeSelect={true}
					name="end_date" className='form-control' onChange={this.changeDateRangeHandler}  />
				</div>
			</div>
			<div className="row mt-2">
				<div className='col-3'>
					Nuevo estado del artículo
				</div>
				<div className='col-9'>
					<select className="form-control" id="status" name="status" onChange={this.handleStatusChange} value={this.state.status}>
						<option value='0'>{this.getTrad("selectAnOption")}</option>
						<option value="1">
							{this.getTrad("availableStatus")}
						</option>
						<option value="2">
							{this.getTrad("occupedStatus")}
						</option>
						<option value="3">
							{this.getTrad("repairingStatus")}
						</option>
						<option value="4">
							{this.getTrad("rentedStatus")}
						</option>
						<option value="5">
							{this.getTrad("soldStatus")}
						</option>
					</select>
				</div>
			</div>
			<div className="row mt-2">
				<div className="col-3">
					{this.getTrad("selectArticle")}
				</div>
				<div className="col-9">
					<SearchAutocomplete data={this.state.articlesFromApi} selected={this.state.currentSelection}
						lookFor={'completeName'} displayField={'completeName'} 
						onOptionSelected={this.changeArticlesHandler} />
				</div>
			</div>
			</>
		:undefined
    }

	handleStatusChange(event){
		if(event.target.name === 'status'){
			this.setState(prevState => {
				return {
					...prevState,
					status: event.target.value
				}
			})
		}
	}

    addCompleteName(articles, onlyOneElement){
    	if(articles === null) return [];
    	if(onlyOneElement) articles = [articles];
		articles = articles.map?articles.map(article => {
			article.completeName = article.name+' ('+article.code+')'
			return article;
		}):[];

		return onlyOneElement?articles.pop():articles;
    }

    setCurrentSelection(selection){
		this.setState(prevState => {
			return {
				...prevState,
					currentSelection: selection!== undefined?this.addCompleteName(selection, true):0
			}
		});
    }

    articleSelected(){

		const returnedValue = {
			article: this.state.selectedArticles,
			start_date: this.state.start_date,
			end_date: this.state.end_date,
			status: this.state.status
		}

		this.props.onArticleSelected(returnedValue, this.props.name);
    }

    renderButtons(){
    	const buttons = [
			{shown: 'Aplicar', close: false, callback: this.articleSelected, behaviour: 'main'},
			{shown: 'Cerrar', close: true}
		];
		return buttons.map( (button,idx) => {
			return (<button type="button" key={"modal_btn_"+idx}
				className={button.behaviour === 'main'?"btn btn-primary":"btn btn-secondary"} 
				data-dismiss={button.close === true?"modal":undefined}
				onClick={this.assignCallback.bind(this,button)}>
				{button.shown}
			</button>)
		})
    }

    changeArticlesHandler(elem){
		this.setState(prevState => {
			return {
				...prevState,
					selectedArticles: elem
			}
		});
    }

	changeDateRangeHandler(date, input){

		if(input.name === 'start_date'){

			this.setState(prevState => {
				return {
					...prevState,
					start_date: date
				}
			},this.callGetArticles)
		}

		if(input.name === 'end_date'){

			this.setState(prevState => {
				return {
					...prevState,
					end_date: date
				}
			},this.callGetArticles)
		}
    }
}

export default ArticleSelector;
